<template>
  <page class="bg-color">
    <div class="paying-page">
      <div class="main">
        <div class="address" v-if="isAddress">
          <div class="contact ft-14">收货地址</div>
          <div class="use-code" @click="toAddress" v-if="userAddress">
            <div class="tel ft-14">{{ userAddress.consignee }}&nbsp;{{ userAddress.mobile }}</div>
            <div class="add ft-14">
              {{ userAddress.provinceCn }}{{ userAddress.cityCn }}{{ userAddress.districtCn
              }}{{ userAddress.address }}
            </div>
            <a href="javascript:;" class="toAdd"><van-icon name="arrow" class="right-arrow" /></a>
          </div>
          <van-cell class="no-addr" v-else title="暂未获取收货地址信息" is-link to="address" />
        </div>
        <van-field
          type="number"
          class="margin-bottom-10 mobile-input"
          v-model="form.mobile"
          v-else
          label="联系手机号"
          placeholder="输入手机号"
          maxlength="11"
        />
        <div class="no_stock" v-if="noStockSecond">{{ stockSecondMsg }}</div>
        <div class="use-code ft-14">
          <van-cell-group v-if="useCode">
            <van-cell title="使用C码" />
          </van-cell-group>
          <van-cell-group v-else>
            <van-cell title="发票信息" is-link :value="'电子发票-' + form.invPayee" @click="showPopup" />
          </van-cell-group>
        </div>

        <!-- <div class="use-code bonus-list" v-if="bonusList" @click="showBonus = true">
          <van-cell title="优惠信息" is-link>
            <div class="discount-info" v-if="selectionBonus"><span class="text">{{selectionBonus.text}}</span>优惠{{selectionBonus.money}}元</div>
            <div class="" v-else>暂不使用优惠</div>
          </van-cell>
        </div>
        <div class="use-code bonus-list" v-else>
          <van-cell title="优惠信息" value="无可用优惠" is-link />
        </div> -->

        <!-- 秒杀商品不支持选择优惠券 拼团订单不支持优惠券-->
        <div v-if="buyType !== 5">
          <div class="cell-view" v-if="buyType == '4'">
            <van-cell title="优惠信息" value="不可用优惠" />
          </div>
          <div
            class="cell-view"
            @click="showBonus = true"
            v-else-if="bonusList && bonusList.length > 0 && buyType != '3'"
          >
            <van-cell
              title="优惠信息"
              is-link
              v-if="selectionBonus"
              :value="'优惠' + selectionBonus.bonusMoney + '元'"
              @click="showBonus = true"
            />
            <van-cell title="优惠信息" is-link v-else value="暂不使用优惠" @click="showBonus = true" />
          </div>
          <div class="cell-view" v-else>
            <van-cell title="优惠信息" value="无可用优惠" />
          </div>
        </div>

        <div class="goods-total">
          <!-- 酷币xx + ￥xx -->
          <van-card
            class="goods-list"
            v-for="(item, index) in goodsList"
            :key="index"
            :title="item.goodsName"
            :desc="coin && buyType === 5 ? coin : '￥' + item.goodsPrice + ' X ' + item.goodsNumber"
            :thumb="item.gmSku.skuThumb"
          />
          <div class="total-msg">
            <div class="discount">
              <span class="fl">商品金额合计</span>
              <span class="fr text-a-r">{{ Number(orderMoney).toFixed(2) }}元</span>
            </div>
            <div class="discount">
              <span class="fl">配送费用</span>
              <span class="fr text-a-r">{{ finalPrice.shippingMoney }}元</span>
            </div>
            <div class="discount">
              <span class="fl">限量特惠</span>
              <span class="fr text-a-r">0.00元</span>
            </div>
            <div class="discount">
              <span class="fl">优惠金额</span>
              <span class="fr text-a-r">{{ Number(finalPrice.bonusMoney).toFixed(2) }}元</span>
            </div>
            <div class="discount" v-if="buyType === 5">
              <span class="fl">酷币抵扣</span>
              <span class="fr text-a-r">
                {{ finalPrice.useCoin ? Number(finalPrice.useCoin.useCoin) : 0 }}酷币
              </span>
            </div>
          </div>
          <!-- TODO  钱包抵扣  -->
          <div
            class="goods-cell"
            v-if="cashDeductionDTO.cashMoney && cashDeductionDTO.useCashDeduction && type != 6"
          >
            <div class="cell-line" style="display：flex;align-items: center;justify-content: space-between;">
              <span class="fl" style="font-size: 28rpx">
                抵扣（钱包共{{ cashDeductionDTO.cashMoney }}元，最高可抵扣{{ finalPrice.cashDeductionMoney }}元）
              </span>
              <van-switch
                class="switch"
                size="20px"
                v-model="deductionCheck"
                active-color="#07c160"
                @change="deductionChange"
              />
            </div>
          </div>

          <div class="integral" v-if="userIntegral.userIntegral && buyType != '4'">
            <span class="fl">
              积分 共{{ userIntegral.userIntegral }}积分 可用{{
                Number(userIntegral.bonusMoney * 100).toFixed(0)
              }}积分 抵￥{{ Number(userIntegral.bonusMoney).toFixed(2) }}
            </span>
            <van-switch
              class="switch"
              size="20px"
              v-model="userIntegral.check"
              active-color="#07c160"
              @change="switchIntegral"
            />
          </div>
          <div class="actual">
            <span class="fl">应付款金额</span>
            <span class="color-orange fr">
              {{ Number(finalPrice.afterBonusAndCashDeductionMoney + finalPrice.shippingMoney).toFixed(2) }}元
            </span>
          </div>
        </div>
      </div>
      <div class="footer-box">
        <van-submit-bar
          class="change-position"
          :price="Number(finalPrice.afterBonusAndCashDeductionMoney + finalPrice.shippingMoney) * 100"
          button-text="立即购买"
          @submit="onSubmit"
        />
      </div>
    </div>

    <div v-if="showBonus" class="bonus-box" position="bottom" @click.stop="showBonus = false">
      <div class="coupon-list">
        <div
          class="coupon-item"
          v-for="(item, index) in bonusList"
          :key="index"
          :class="item.isUse ? 'isuse' : 'nouse'"
        >
          <div class="coupon_active">
            <div class="money">
              {{ item.actType !== 2 ? item.couponInfo.mainText : item.couponInfo.mainText }}
            </div>
            <!-- 特价 秒杀 无使用门槛 -->
            <div class="use-explain" v-if="item.actType === 5">无使用门槛</div>
            <div class="use-explain" v-else-if="item.actType === 0">
              {{ item.couponInfo.limitText }}
            </div>
            <div class="use-explain" v-else-if="item.actType === 2">
              满{{ item.actPromotion.actPromotionGoodsBonusDtoList[0].actPrice }}元可用
            </div>
            <div class="use-explain" v-else>满{{ item.orderMoney }}元可用</div>
          </div>
          <div class="coupon-info" v-if="item.isUse" @click="choiceBonus(item)">
            <div class="bonus-name">{{ item.couponInfo.couponName }}</div>

            <div class="bonus-time">{{ item.couponInfo.validPeriod }}</div>
            <div class="checkbox" v-if="selectionBonus">
              <img
                class="img-100"
                src="https://img2.coocaa.com/ui/partner-mini-program/checked.png"
                v-if="item.couponCode === selectionBonus.couponCode"
              />
              <div class="check" v-else></div>
            </div>
            <div class="checkbox" v-else>
              <div class="check"></div>
            </div>
          </div>
          <div class="coupon-info" v-else>
            <div class="bonus-name">{{ item.couponInfo.couponName }}</div>
            <div class="bonus-time">{{ item.couponInfo.validPeriod }}</div>
            <div class="checkbox" v-if="selectionBonus">
              <img
                class="img-100"
                src="https://img2.coocaa.com/ui/partner-mini-program/checked.png"
                v-if="item.couponCode === selectionBonus.couponCode"
              />
              <div class="check" v-else></div>
            </div>
            <div class="checkbox" v-else>
              <div class="check"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showInvoice" position="bottom" :style="{ height: '70%' }">
      <div class="invoice-title">
        <van-cell-group>
          <van-cell title="发票类型" value="电子普通发票" />
        </van-cell-group>
      </div>
      <div class="invoice-choice">
        <van-cell-group class="nvoice-cell">
          <div class="field">
            <van-cell class="field-label" title="发票抬头" />
            <div class="field-value">
              <van-button
                class="button"
                :class="[invoiceMsg.type === 0 ? 'cur' : '']"
                slot="button"
                size="small"
                @click="changeBtn(0)"
              >
                个人
              </van-button>
              <van-button
                class="button"
                :class="[invoiceMsg.type === 1 ? 'cur' : '']"
                slot="button"
                size="small"
                @click="changeBtn(1)"
              >
                单位
              </van-button>
            </div>
          </div>
          <div v-if="invoiceMsg.type === 0">
            <van-field v-model="invoiceMsg.invContent" maxlength="10" placeholder="请输入个人姓名" />
          </div>
          <div v-else>
            <van-field v-model="invoiceMsg.invContent" maxlength="30" placeholder="请输入单位名称" />
            <van-field
              v-model="invoiceMsg.taxpayerNumber"
              maxlength="30"
              placeholder="纳税人识别号或统一社会信用代码"
            />
          </div>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="发票内容" value="明细" />
          <van-cell title="发票金额" :value="orderMoney" />
          <div class="pd15">
            <van-button type="danger" size="large" @click="submitOrder" class="submit-btn">提交</van-button>
          </div>
        </van-cell-group>
      </div>
    </van-popup>
  </page>
</template>
<script>
import { Dialog } from 'vant'
import { mapActions, mapMutations } from 'vuex'
import { $platformCode } from '@/common'
import { saveOrderExchangeBuy } from '@/service/modules/order'
export default {
  components: {},
  computed: {
    ccLogParams() {
      // 制造一个字段用循环构造数据
      let map = {
        commodity_id: 'goodsId',
        commodity_name: 'goodsName',
        goods_price: 'goodsPrice',
        original_price: 'marketPrice',
        commodity_type: 'goodsClassify',
        product_quantity: 'goodsNumber'
      }
      // 需要提交埋点的数据
      let param = {}
      let total = 0
      this.goodsList.forEach((item) => {
        total += parseInt(item.goodsNumber)
        // 依次记录每个商品的id,名字,金额,种类,数量
        for (let key in map) {
          let name = map[key]
          if (param[key] === undefined) {
            param[key] = ''
          }
          param[key] = `${param[key]}${item[name]},`
        }
      })
      // param里每个字段最后都是个逗号,需要-1处理
      for (let key in map) {
        param[key] = param[key].substr(0, param[key].length - 1)
      }
      let getFromUrl = this.getFromUrl
      if (getFromUrl === '确认订单') {
        // 如果当前的轨迹只有确认订单,那大概率是虚拟卡-跳转登录-确认订单,导致缺少轨迹
        getFromUrl = '商品详情,确认订单'
        this.setLastPageList(getFromUrl.split(','))
      }
      return {
        ...param,
        total_price_of_commodity: Number(this.orderMoney).toFixed(2),
        total_number_of_commodity: total,
        // user_type: this.isFormalEmp,
        user_empNo: this.getEmpNo || '',
        frontPageName: getFromUrl,
        page_name: '确认订单'
      }
    }
  },
  data() {
    return {
      coin: null,
      isAddress: true,
      userIntegral: {
        check: false
      },
      showBonus: false,
      isIntegral: false,
      goods: {},
      goodsList: [],
      useCode: false,
      getNothing: true,
      userAddress: null,
      number: null,
      goodsId: null,
      queryActCode: null,
      bonusList: [], // 优惠信息列表
      SpecialList: [], // 特价列表
      selectionBonus: null, // 选中的优惠券
      selectionSpecial: null, // 选中的特价
      userLevels: null, // 选中的用户等级
      showInvoice: false,
      orderMoney: 0,
      buyType: parseInt(this.$route.query.buyType), // 1代表购物车 2代表立即购买  3秒杀活动 4拼团
      cartIds: [],
      form: {
        invPayee: '个人',
        invType: '3',
        loginType: '',
        adLinkApply: ''
      },
      invoiceMsg: {
        // 0 代表个人，1代表单位
        type: 0,
        invContent: '个人',
        taxpayerNumber: '' // 纳税人识别号
      },
      searchKeyword: '',
      addItem: null,
      deductionCheck: true,
      newBounsList: [],
      finalPrice: {
        afterBonusOrderMoney: 0,
        bonusMoney: 0,
        useCoin: {
          useCoin: 0
        }
      },
      cashDeductionDTO: {},
      SKBuy: null, // 秒杀信息
      exchangeBuy: null, // 兑换信息
      noStockSecond: false,
      stockSecondMsg: '',
      queryPreOrderSn: '' // 预订单号
    }
  },
  methods: {
    // ...mapActions(['setEventTracking']),
    ...mapMutations(['setLastPageList', 'pushPageList']),
    switchIntegral(value) {
      if (value) {
        this.selectionBonus = null
      }
      this.getCalculateSuperimposeAct()
    },
    showPopup() {
      this.showInvoice = true
    },
    submitOrder() {
      let parmas = {}
      parmas = this.invoiceMsg
      if (parmas.invContent === '') {
        this.$toast('发票抬头不能为空')
        return false
      } else if (parmas.taxpayerNumber === '' && parseInt(parmas.type) === 1) {
        this.$toast('纳税人识别号不能为空')
        return false
      } else {
        this.form.invPayee = parmas.invContent
        if (parseInt(parmas.type) === 1) {
          this.form.taxpayerNumber = parmas.taxpayerNumber
        } else {
          this.form.taxpayerNumber = ''
        }
        this.showInvoice = false
      }
    },
    changeBtn(type) {
      this.invoiceMsg = {
        type: type,
        invContent: type === 0 ? '个人' : '',
        taxpayerNumber: ''
      }
    },
    onSubmit() {
      if (!this.isAddress && !this.form.mobile) {
        this.$toast('请输入联系手机号！')
        return false
      } else if (!this.isAddress && !/^1\d{10}$/.test(this.form.mobile)) {
        this.$toast('请输入正确的联系手机号！')
        return false
      } else if (this.isAddress && !this.form.addressId) {
        this.$toast('请添加收货地址！')
        return false
      } else if (this.noStockSecond) {
        this.$toast(this.stockSecondMsg)
        return false
      }
      this.pushPageList('提交订单')
      this.$constants.submitccLog('partner_mini_page_click', '填写订单-点击提交订单', {
        ...this.ccLogParams,
        button_name: '提交订单'
      })
      this.form.invTaxpayerNumber = this.form.taxpayerNumber
      if (this.buyType === 1) {
        // 购物车
        let param = JSON.parse(JSON.stringify(this.form))
        param.goodsNum = param.num
        param.superimposeActDTOS = []
        const selectionBonus = this.selectionBonus
        let quanC = {}
        if (selectionBonus) {
          if (selectionBonus.actType === 0) {
            quanC.couponCode = selectionBonus.couponCode
            quanC.actType = selectionBonus.actType
          } else {
            quanC.actCode = selectionBonus.actPromotion.actCode
            quanC.actType = selectionBonus.actType
          }
          param.superimposeActDTOS.push(quanC)
        }
        if (this.userIntegral.check) {
          param.superimposeActDTOS.push({
            actType: 3,
            actCode: this.userIntegral.actPromotion.actCode
          })
        } else {
          this.newBounsList.forEach((item) => {
            param.superimposeActDTOS.push({
              actType: item.actType,
              actCode: item.actPromotion.actCode
            })
          })
        }
        param.platformCode = $platformCode
        param.useCashDeduction = this.deductionCheck ? 1 : 0
        param.preOrderSn = this.queryPreOrderSn
        this.$service.saveOrderCartNew(param).then((res) => {
          // 测试
          const data = res.data
          if (data.orderAmount) {
            // this.webPay(data)
          } else {
            this.$router.push({
              name: 'pay-success',
              query: {
                orderSn: data.orderSn,
                goodsType: this.$route.query.goodsType,
                amount: data.orderAmount
              }
            })
          }
        })
      } else if (this.buyType === 2) {
        // 正常购买
        let param = JSON.parse(JSON.stringify(this.form))
        param.goodsNum = param.num
        param.superimposeActDTOS = []
        const selectionBonus = this.selectionBonus
        let quanC = {}
        if (selectionBonus) {
          if (selectionBonus.actType === 0) {
            quanC.couponCode = selectionBonus.couponCode
            quanC.actType = selectionBonus.actType
          } else {
            quanC.actCode = selectionBonus.actPromotion.actCode
            quanC.actType = selectionBonus.actType
          }
          param.superimposeActDTOS.push(quanC)
        }
        if (this.userLevels) {
          param.superimposeActDTOS.push({
            actType: 22,
            actCode: this.userLevels.actPromotion.actCode
          })
        }
        if (this.userIntegral.check) {
          param.superimposeActDTOS.push({
            actType: 3,
            actCode: this.userIntegral.actPromotion.actCode
          })
        } else {
          this.newBounsList.forEach((item) => {
            param.superimposeActDTOS.push({
              actType: item.actType,
              actCode: item.actPromotion.actCode
            })
          })
        }
        param.useCashDeduction = this.deductionCheck ? 1 : 0
        param.platformCode = $platformCode
        param.preOrderSn = this.queryPreOrderSn
        this.$service.saveOrderGetBuyNew(param).then((res) => {
          // 测试
          const data = res.data
          if (data.orderAmount) {
            this.webPay(data)
          } else {
            this.$router.push({
              name: 'pay-success',
              query: {
                orderSn: data.orderSn,
                goodsType: this.$route.query.goodsType,
                amount: data.orderAmount
              }
            })
          }
        })
      } else if (this.buyType === 3) {
        // 秒杀
        let param = JSON.parse(JSON.stringify(this.form))
        param.actCode = this.queryActCode
        param.goodsNum = this.number
        param.useCashDeduction = this.deductionCheck ? 1 : 0
        param.goodsId = this.goodsId
        param.preOrderSn = this.queryPreOrderSn
        this.$service.saveOrderSkBuy(param).then((res) => {
          const data = res.data
          // 测试
          if (data.orderAmount) {
            this.webPay(data)
          } else {
            this.$router.push({
              name: 'pay-success',
              query: {
                orderSn: data.orderSn,
                goodsType: this.$route.query.goodsType,
                amount: data.orderAmount
              }
            })
          }
        })
      } else if (this.buyType === 4) {
        // 拼团
        // let param = JSON.parse(JSON.stringify(this.form))
        // param.actCode = this.queryActCode
        // param.goodsNum = this.number
        // param.goodsId = this.goodsId
        // param.groupCode = this.$route.query.groupCode
        // if (param.groupCode === 'undefined') {
        //   delete param.groupCode
        // }
        // this.$service.saveOrderGroupBuy(param).then(res => {
        //   const data = res.data
        //   // 测试
        //   if (data.orderAmount) {
        //     this.webPay(data)
        //   } else {
        //     this.$router.push({
        //       name: 'collageDetail',
        //       query: {
        //         orderSn: data.orderSn,
        //         fromPay: 1
        //       }
        //     })
        //   }
        // })
      } else if (this.buyType === 5) {
        // 兑换
        let param = JSON.parse(JSON.stringify(this.form))
        param.exchangeCode = this.queryActCode
        param.goodsNum = this.number
        param.goodsId = this.goodsId
        param.preOrderSn = this.queryPreOrderSn
        param.useGoldCoin = 1
        this.$service.saveOrderExchangeBuy(param).then((res) => {
          const data = res.data
          // 测试
          if (data.orderAmount) {
            this.webPay(data)
          } else {
            this.$router.push({
              name: 'pay-success',
              query: {
                orderSn: data.orderSn,
                goodsType: this.$route.query.goodsType,
                amount: data.orderAmount
              }
            })
          }
        })
      }
    },
    webPay(data) {
      const orderSn = data.merger ? data.mergerOrderSn : data.orderSn
      let endOrderSn = data.merger ? data.orderSn : data.mergerOrderSn
      // 数据埋点,需要记录对应order的轨迹记录
      // 不同的店铺会产生多个不同的订单,直接使用带'-'的sn保存
      // this.setEventTracking({
      //   vm: this,
      //   orderNo: data.orderSn
      // })
      let returnUrl =
        window.location.origin +
        '/pay-success?orderSn=' +
        orderSn +
        '&goodsType=' +
        this.$route.query.goodsType +
        '&sn=' +
        endOrderSn
      this.$service
        .webPay({
          merger: data.merger,
          orderAmount: data.orderAmount,
          orderSn: orderSn,
          payWay: this.$getBrowser(),
          returnUrl
        })
        .then((res) => {
          window.location = res.data
        })
    },
    toAddress() {
      this.$router.push({
        name: 'address',
        query: {
          flag: 'true',
          number: this.number,
          goodsId: this.goodsId.toString(),
          buyType: this.buyType,
          actCode: this.queryActCode
        }
      })
    },
    queryAddress() {
      this.$service.getAreasListNew().then((res) => {
        const data = res.data
        if (data.length > 0) {
          let addr = []
          data.forEach((item) => {
            if (item.isDefault) {
              addr = item
            }
          })
          this.form.addressId = addr.addressId || ''
          if (this.addItem && this.addItem.addressId) {
            this.userAddress = this.addItem
            this.form.addressId = this.addItem.addressId
          } else {
            this.userAddress = addr
          }
          this.checkShippingArea()
        }
      })
    },
    // 获取立即购买商品详情接口
    async queryOrderMsg() {
      let res
      if (this.buyType === 4) {
        // this.deductionCheck = false
        // res = await this.$service.groupBuyNew({
        //   goodsNum: this.number,
        //   goodsId: this.goodsId,
        //   actCode: this.queryActCode
        // })
      } else {
        res = await this.$service.getBuyNew({
          goodsNum: this.number,
          goodsId: this.goodsId
        })
      }
      if (res.code === 200) {
        const data = res.data
        const carts = data.carts
        const isAddress = carts[0].spuType === 1
        this.isAddress = isAddress
        this.form.goodsId = carts[0].goodsId
        this.form.num = carts[0].goodsNumber
        this.form.identifyCode = data.identifyCode
        this.goodsList = data.carts
        this.cashDeductionDTO = data.cashDeductionDTO || {}
        // this.orderMoney = data.orderMoney
        this.$constants.submitccLog('partner_mini_page_show', '下单页曝光', {
          ...this.ccLogParams,
          button_name: ''
        })
        if (isAddress) {
          this.queryAddress()
        }
        // this.bonusList = data.bonusList
        this.setBonusList(data.bonusV2List)
      }
    },
    choiceBonus(checked) {
      const currSelect = this.bonusList.find((item) => item.check) || {}
      this.bonusList.forEach((item) => {
        if (currSelect.couponCode === checked.couponCode) {
          item.check = false
        } else {
          item.check = checked.couponCode === item.couponCode
        }
      })

      if (checked.check) {
        this.selectionBonus = checked
      } else {
        this.selectionBonus = null
      }
      this.showBonus = false

      this.userIntegral.check = false

      this.getCalculateSuperimposeAct()
    },
    setBonusList(data) {
      if (this.$constants.getStorage('showType') !== 'purchase') {
        // "1满折，2满减，3积分，4优惠券，5秒杀，22用户等级
        let bonusList = []
        let selection = null

        data.map((item) => {
          if (item.defaultCheck) {
            this.newBounsList.push(item)
          }

          item.isUse = false
          if (item.actType === 4) {
            // 特价
            if (item.check) {
              item.isUse = true
              this.selectionSpecial = item // 特价选中的信息
            } else {
              this.selectionSpecial = null
            }
            this.SpecialList.push(item)
          } else if (item.actType === 22) {
            // 用户等级
            this.userLevels = item
          } else if (item.actType === 3) {
            // 积分
            this.userIntegral = item
          } else if (item.actType === 5) {
            // 秒杀
            if (item.defaultCheck) {
              this.SKBuy = item
            } else {
              this.SKBuy = null
            }
          } else if (item.actType === 7) {
            // 兑换
            if (item.defaultCheck) {
              this.exchangeBuy = item
            } else {
              this.exchangeBuy = null
            }
          } else {
            // 优惠券  折扣等
            if (item.check) {
              item.isUse = true
              selection = item
            }
            bonusList.push(item)
          }
        })
        // 优惠列表
        this.bonusList = bonusList
        // 选中的这一条优惠信息
        this.selectionBonus = selection

        // if (this.selectionSpecial) {
        //   // 默认选择的是特价活动
        //   this.getBonusList('bonus')
        // } else if (this.selectionBonus) {
        //   // 默认选择的是优惠信息
        //   this.getBonusList('special')
        // } else {
        //   // 计算订单价格
        //   this.getCalculateSuperimposeAct()
        // }
        // this.$service.getCanSuperimposeActList 已经废弃， 直接计算最后的金额
        this.getCalculateSuperimposeAct()
      }
    },
    getBonusList(type) {
      let param = {
        defaultSelectActs: [],
        goodsAndNumDTOS: []
      }
      this.goodsList.forEach((list) => {
        param.goodsAndNumDTOS.push({
          goodsId: list.goodsId,
          num: list.goodsNumber
        })
      })
      this.newBounsList.forEach((item) => {
        param.defaultSelectActs.push({
          actType: item.actType,
          actCode: item.actPromotion.actCode
        })
      })
      // 选择特价 查询可叠加的 优惠
      this.$service.getCanSuperimposeActList(param).then((res) => {
        if (type === 'bonus') {
          if (res.length === 0) {
            this.bonusList.forEach((item) => {
              item.isUse = true
            })
          } else {
            this.bonusList.forEach((item) => {
              item.isUse = false
              res.forEach((list) => {
                if (list.couponCode === item.couponCode) {
                  item.isUse = true
                }
              })
            })
          }
        } else {
          this.bonusList.forEach((item) => {
            item.isUse = true
          })
        }
      })
      // 计算订单价格
      this.getCalculateSuperimposeAct()
    },
    // 计算最后的订单金额
    getCalculateSuperimposeAct() {
      let params = {
        goodsAndNumDTOS: [],
        superimposeActDTOS: [],
        useCashDeduction: this.deductionCheck ? 1 : 0
      }
      if (this.buyType === 1) {
        this.goodsList.forEach((item) => {
          params.goodsAndNumDTOS.push({
            goodsId: item.goodsId,
            num: item.goodsNumber
          })
        })
      } else {
        params.goodsAndNumDTOS.push({
          goodsId: this.goodsId,
          num: this.number
        })
      }

      // 拼团只需要这个就够了
      this.newBounsList.forEach((item) => {
        params.superimposeActDTOS.push({
          actType: item.actType,
          actCode: item.actPromotion.actCode
        })
      })
      //  拼团不能选择优惠券
      if (this.selectionBonus && this.buyType !== 4) {
        params.superimposeActDTOS = [
          {
            couponCode: this.selectionBonus.couponCode,
            actType: this.selectionBonus.actType
          }
        ]
      }
      // 积分
      if (this.userIntegral.check) {
        params.superimposeActDTOS = [
          {
            actType: 3,
            actCode: this.userIntegral.actPromotion.actCode
          }
        ]
      }
      // 特价商品
      if (this.selectionSpecial) {
        let has = params.superimposeActDTOS.some((item) => {
          return item.actCode === this.selectionSpecial.actPromotion.actCode
        })
        if (!has) {
          params.superimposeActDTOS.push({
            actType: 4,
            actCode: this.selectionSpecial.actPromotion.actCode
          })
        }
      }
      // 用户等级
      if (this.userLevels) {
        params.superimposeActDTOS.push({
          actType: 22,
          actCode: this.userLevels.actPromotion.actCode
        })
      }
      // 秒杀
      if (this.SKBuy) {
        params.superimposeActDTOS = [
          {
            actType: 5,
            actCode: this.SKBuy.actPromotion.actCode
          }
        ]
      }
      // 兑换
      if (this.exchangeBuy) {
        params.superimposeActDTOS = [
          {
            actType: 7,
            actCode: this.exchangeBuy.actPromotion.actPromotionExchangeGoodsDTOList[0].exchangeCode
          }
        ]
        params.useGoldCoin = 1
      }

      this.$service.getCalculateSuperimposeAct(params).then((res) => {
        this.finalPrice = res.data
        if (res.data.useCoin) {
          let COIN = res.data.useCoin
          this.coin = '(酷币' + COIN.useCoin + ' +' + '￥' + COIN.actPrice + ') X ' + COIN.buyNumber
        }
        this.orderMoney = res.data.orderMoney
      })
    },
    // 秒杀获取商品详情
    secondKill() {
      this.$service
        .skBuyNew({
          actCode: this.queryActCode,
          goodsId: this.goodsId,
          goodsNum: this.number
        })
        .then((res) => {
          if (res.code === 200) {
            let msg = res.message
            const data = res.data
            this.goodsList = data.carts
            this.cashDeductionDTO = data.cashDeductionDTO || {}
            const isAddress = data.carts[0].spuType === 1
            this.isAddress = isAddress
            if (isAddress) {
              this.queryAddress()
            }
            this.$constants.submitccLog('partner_mini_page_show', '下单页曝光', {
              ...this.ccLogParams,
              button_name: ''
            })
            this.form.identifyCode = data.identifyCode
            this.form.actCode = this.queryActCode
            this.setBonusList(data.bonusV2List)
          } else {
            Dialog.alert({
              message: res.message,
              theme: 'round-button'
            }).then(() => {
              this.$router.push({
                name: 'goods-detail',
                query: {
                  goodsId: this.goodsId
                }
              })
            })
          }
        })
    },
    exchangeGoods() {
      this.$service
        .getExchangeBuy({
          exchangeCode: this.queryActCode,
          goodsId: this.goodsId,
          goodsNum: this.number
        })
        .then((res) => {
          const data = res.data
          this.goodsList = data.carts
          this.cashDeductionDTO = data.cashDeductionDTO || {}
          const isAddress = data.carts[0].spuType === 1
          this.isAddress = isAddress
          if (isAddress) {
            this.queryAddress()
          }
          // this.orderMoney = data.orderMoney
          this.$constants.submitccLog('partner_mini_page_show', '下单页曝光', {
            ...this.ccLogParams,
            button_name: ''
          })
          this.form.identifyCode = data.identifyCode
          this.form.actCode = this.queryActCode
          this.setBonusList(data.bonusV2List)
        })
    },
    // 获取购物车订单详情接口
    async queryCartOrderMsg() {
      let params = {}
      if (this.queryPreOrderSn) {
        params.preOrderSn = this.queryPreOrderSn
      }
      this.$service.cartBuy(params).then((res) => {
        const data = res.data
        const carts = data.carts
        this.cartIds = carts.map((item) => item.id)
        this.form.cartIds = this.cartIds
        this.goodsList = carts
        this.cashDeductionDTO = data.cashDeductionDTO || {}
        // this.orderMoney = data.orderMoney
        const params = {
          ...this.ccLogParams,
          button_name: ''
        }
        this.$constants.submitccLog('partner_mini_page_show', '下单页曝光', params)
        this.setBonusList(data.bonusV2List)
        this.queryAddress()
      })
    },
    deductionChange(value) {
      this.deductionCheck = value
      this.getCalculateSuperimposeAct()
    },
    // 检查地址
    async checkShippingArea() {
      try {
        const addressId = this.form.addressId
        const goodsIds = this.goodsList.map((item) => item.goodsId)
        const res = await this.$service.checkShippingArea({
          addressId,
          goodsIds
        })
        this.stockSecondMsg = res.message
        this.noStockSecond = res.code !== 200
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted() {
    const { addItem, number, goodsId, actCode, buyType, preOrderSn } = this.$route.query
    if (addItem) {
      this.addItem = addItem
      // this.queryOrderMsg()
    }
    this.number = number || 1
    this.goodsId = goodsId
    this.queryActCode = actCode
    this.buyType = parseInt(buyType)
    this.queryPreOrderSn = preOrderSn || ''
    const empNo = this.$getCookie('fromCode')
    const shareApplyId = this.$getCookie('shareApplyId')
    const usersState = this.$service.state
    this.form.loginType = usersState.inited ? usersState.user.loginType : ''
    if (empNo) {
      this.form.empNo = empNo
    }
    if (shareApplyId) {
      this.form.adLinkApply = shareApplyId
    } else if (this.getApplyId) {
      // 如果没有外部分享的id 则读取自己的
      this.form.adLinkApply = this.getApplyId
    }
    // buyType 1代表购物车 2代表立即购买 3秒杀活动  4代表拼团
    if (this.buyType === 1) {
      this.queryCartOrderMsg()
    } else if (this.buyType === 3) {
      this.secondKill()
    } else if (this.buyType === 5) {
      this.exchangeGoods()
    } else {
      this.queryOrderMsg()
    }
    this.SpecialList = [] // 清空弹窗特价列表
  }
}
</script>

<style lang="stylus" scoped>
@import './paying.styl'
</style>
